// extracted by mini-css-extract-plugin
export default {"block":"yd","smallprint":"zd","asterisk":"Ad","label":"Bd"};